@if (footerStore(); as footer) {
  @defer (on idle; on timer(5s)) {
    @let items = footer.items;
    @let menu = footer.menu;
    <footer class="mask-curve-top z-40 bg-anis py-[80px]">
      <div class="centered-with-padding grid grid-cols-1 gap-x-3 gap-y-9 desk:grid-cols-12 desk:gap-y-4">
        <div class="order-1 w-[275px] desk:col-span-4 desk:row-span-2 desk:w-[300px]">
          @if (items.title; as title) {
            <app-title [title]="title" size="custom-47" />
          }
        </div>
        <div class="order-3 grid grid-cols-[66px_auto] items-center gap-4 desk:order-2 desk:col-span-8">
          @if (items.certification.data; as certification) {
            <app-svg [src]="certification.logo.svg" [width]="66" class="rotate-[5deg]" />
            <div class="max-w-[580px]">
              <div [innerHtml]="certification.description" handleHtmlLinks></div>
              <div class="text-sm">{{ certification.ifClauses }}</div>
            </div>
          }
        </div>
        <div class="order-4 self-end desk:order-3 desk:col-span-3">
          @if (items.storeInfo.data; as storeInfo) {
            <div class="grid grid-cols-[72px_130px_80px] items-center">
              <div class="font-title text-[40px]">{{ storeInfo.totalStores }}</div>
              <div class="pl-2.5 font-title text-[15px]">{{ storeInfo.description }}</div>
              <app-svg [src]="storeInfo.icon.svg" [width]="50" />
            </div>
            @let cta = storeInfo.cta;
            @if (cta && cta.url) {
              <app-button [label]="storeInfo.cta.label" [url]="storeInfo.cta.url" theme="WHITE" />
            }
          }
        </div>
        <div class="order-5 self-end desk:order-4 desk:col-span-5">
          @if (items.catalog; as catalog) {
            @if (catalog.data.label; as label) {
              <div class="pb-4 font-bold">{{ label }}</div>
            }
            @let cta = catalog.data.cta;
            @if (cta && cta.url) {
              <app-button [label]="cta.label" [url]="cta.url" theme="WHITE" />
            }
          }
        </div>
        <div class="order-2 w-[300px] self-end desk:order-5 desk:col-span-4">
          @if (items.socialNetworks.data; as socialNetworks) {
            <ng-container *ngTemplateOutlet="socialNetworksTemplate; context: { socialNetworks }" />
          }
        </div>
        <div class="order-6 grid gap-x-3 gap-y-9 desk:col-span-8 desk:grid-cols-12">
          <div class="order-6 col-span-4">
            @if (menu.categories[0]; as firstMenu) {
              <ng-container *ngTemplateOutlet="menuTemplate; context: { menu: firstMenu }" />
            }
          </div>
          <div class="order-7 col-span-4">
            @if (menu.categories[1]; as secondMenu) {
              <ng-container *ngTemplateOutlet="menuTemplate; context: { menu: secondMenu }" />
            }
          </div>
          <div class="order-8 col-span-4">
            @if (menu.categories[2]; as thirdMenu) {
              <ng-container *ngTemplateOutlet="menuTemplate; context: { menu: thirdMenu }" />
            }
          </div>
        </div>
      </div>
    </footer>
  }
}
<ng-template #menuTemplate let-menu="menu">
  <div class="pb-4 font-bold">{{ menu.label }}</div>
  @let items = menu.subItems;
  @if (items && items.length > 0) {
    <ul class="flex flex-col gap-0.5">
      @for (item of items; track index; let index = $index) {
        <li>
          <a [appLink]="item.url" [openInSameTab]="item.openInSameTab">{{ item.label }}</a>
        </li>
      }
    </ul>
  }
</ng-template>
<ng-template #socialNetworksTemplate let-sn="socialNetworks">
  <div class="pb-2.5 font-bold">{{ sn.hashtag }}</div>
  <div class="grid grid-cols-5 gap-x-3">
    @for (picto of sn.pictos; track picto.url) {
      <a
        [href]="picto.url"
        target="_blank"
        rel="noopener noreferrer"
        class="size-[50px] overflow-hidden transition-transform duration-300 ease-in-out hover:scale-125">
        <app-svg [src]="picto.svg" [width]="32" [height]="32" />
      </a>
    }
  </div>
</ng-template>
